import { ReactElement, useCallback } from 'react';

import { Translate } from '@dreryk/react-common';
import { Dropdown, useHistoryPushWithBackAction } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';
import { visitPaths } from '~libs.desktop.shared.paths';

import { appointmentsTranslationKeys, visitTranslationKeys } from '../../../../translations';

type AppointmentRestoreDropdownItemProps = {
   readonly appointmentId: number;
   readonly restoreAvailable: boolean;
};
export const AppointmentRestoreDropdownItem = (props: AppointmentRestoreDropdownItemProps): ReactElement => {
   const creatingAppointmentsAvailable = protectFeature('creatingAppointments');
   const push = useHistoryPushWithBackAction(true);
   const goToCalendar = useCallback(
      (hide) => {
         push(
            visitPaths.getCalendarPath({
               searchParams: {
                  restoreAppointmentId: props.appointmentId,
               },
            }),
            { label: visitTranslationKeys.goBackToAppointmentsList }
         );
         hide();
      },
      [push, props.appointmentId]
   );

   return (
      <Dropdown.Item
         testId={`appointmentRestoreOption${props.appointmentId}`}
         onClick={goToCalendar}
         disabled={!creatingAppointmentsAvailable || !props.restoreAvailable}
      >
         <Dropdown.Item.Tooltip
            testId={'restore'}
            content={appointmentsTranslationKeys.accountPartiallyBlocked}
            disabled={creatingAppointmentsAvailable}
         >
            <Translate>{appointmentsTranslationKeys.restore}</Translate>
         </Dropdown.Item.Tooltip>
      </Dropdown.Item>
   );
};
